export default "__VITE_ASSET__Bp8iLMIv__"